
// API constants - We'll use a dedicated demo API key for Unsplash
export const UNSPLASH_ACCESS_KEY = 'RBGIjm8KdI10XTUPsVznCXvbzhUUVLspbCLZ0iHplek';
export const BASE_URL = 'https://api.unsplash.com';

// Cache duration - 24 hours in milliseconds
export const CACHE_DURATION = 24 * 60 * 60 * 1000;

// Map of blog post categories to Unsplash search terms
export const CATEGORY_TO_SEARCH_TERM: Record<string, string> = {
  'Productivity': 'productivity workspace computer',
  'Business': 'business freelance professional',
  'Finance': 'finance invoice business',
  'Marketing': 'marketing digital workspace',
  'Technology': 'technology computer coding',
  'Design': 'design creative workspace'
};

// Pre-defined high-quality photo IDs for specific blog posts - updated with new business/work stock photos
export const BLOG_POST_IMAGE_MAP: Record<string, string> = {
  // Time Management post - professional workspace with planning tools
  'time-management-techniques-freelancer': 'photo-1507003211169-0a1dd7228f2d',
  
  // Freelance Rates post - businesswoman working on laptop in modern office
  'how-to-set-freelance-rates': 'photo-1573497019940-1c28c88b4f3e',
  
  // Invoicing post - business meeting with documents and laptop
  'invoicing-best-practices': 'photo-1556742049-0cfed4f6a45d',
  
  // Time Tracking post - focused professional working on computer
  'importance-time-tracking-freelance-success': 'photo-1560472354-b33ff0c44a43',
  
  // Client Pipeline post - business team collaboration in modern office
  'building-client-pipeline-sustainable-freelancing': 'photo-1522202176988-66273c2fd55f'
};

// Enhanced fallback images with better category coverage
export const FALLBACK_IMAGES: Record<string, string> = {
  'Productivity': 'https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b?w=800&h=400&fit=crop&crop=center',
  'Business': 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&h=400&fit=crop&crop=center',
  'Finance': 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&h=400&fit=crop&crop=center',
  'Technology': 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=800&h=400&fit=crop&crop=center',
  'Marketing': 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=400&fit=crop&crop=center',
  'Design': 'https://images.unsplash.com/photo-1558655146-364adaf1fcc9?w=800&h=400&fit=crop&crop=center',
  'default': 'https://images.unsplash.com/photo-1499750310107-5fef28a66643?w=800&h=400&fit=crop&crop=center'
};

// Custom uploaded images for specific blog posts
export const CUSTOM_IMAGES: Record<string, string> = {
  // Can be used for future custom uploads
};

// Category-based icons (using Lucide icon names)
export const CATEGORY_ICONS: Record<string, string> = {
  'Productivity': 'clock',
  'Business': 'briefcase',
  'Finance': 'dollar-sign',
  'Marketing': 'megaphone',
  'Technology': 'code',
  'Design': 'palette',
  'default': 'file-text'
};
